import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	//mode: 'history',
	//base: '/addons/we7_wmall/',
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			if (from.meta.keepAlive) {
				from.meta.savedPosition = document.body.scrollTop;
			}
			return { x: 0, y: to.meta.savedPosition || 0};
		}
	},
	routes: [
		{
			path: '/', //根目录
			name: 'index',
			redirect: '/plugin/pages/channel/coupon',
		},
		{
			path: '/pages/home/index', //首页
			name: 'HomeIndex',
			redirect: '/plugin/pages/channel/coupon',
			// meta: {
			// 	keepAlive: true,
			// 	title: '首页'
			// },
			// component: resolve => require(['@/pages/home/home'], resolve),
},
		{
			path: '/pages/public/pay', //支付页面
			name: 'publicPay',
			meta: {
				title: '支付订单'
			},
			component: resolve => require(['@/pages/public/pay'], resolve),
		},
		{
			path: '/plugin/pages/channel/coupon', //领券中心
			name: 'GetCoupon',
			meta: {
				title: '领券中心'
			},
			component: resolve => require(['@/pages/channel/coupon'], resolve),
		},
		
		{
			path: '/pages/auth/login', //登录
			name: 'login',
			meta: {
				title: '登录'
			},
			component: resolve => require(['@/pages/auth/login'], resolve),
		},
		{
			path: '/pages/auth/majia', //登录
			name: 'majia',
			meta: {
				title: '登录'
			},
			component: resolve => require(['@/pages/auth/majia'], resolve),
		},
		{
			path: '/pages/auth/qianfan', //登录
			name: 'qianfan',
			meta: {
				title: '登录'
			},
			component: resolve => require(['@/pages/auth/qianfan'], resolve),
		},
		{
			path: '/pages/auth/register', //注册
			name: 'register',
			meta: {
				title: '注册'
			},
			component: resolve => require(['@/pages/auth/register'], resolve),
		},
		{
			path: '/pages/auth/forget', //忘记密码
			name: 'forget',
			meta: {
				title: '忘记密码'
			},
			component: resolve => require(['@/pages/auth/forget'], resolve),
		},
		{
			path: '/pages/store/paybill', //买单
			name: 'storePaybill',
			meta: {
				title: '买单'
			},
			component: resolve => require(['@/pages/store/ipaybill'], resolve),
		},
		{
			path: '/pages/store/ipaybill', //买单
			name: 'storeiPaybill',
			meta: {
				title: '买单'
			},
			component: resolve => require(['@/pages/store/ipaybill'], resolve),
		},
		
		{
			path: '/package/pages/svip/index', //超级会员
			name: 'svipIndex',
			meta: {
				title: '超级会员'
			},
			component: resolve => require(['@/pages/svip/index'], resolve),
		},
		{
			path: '/package/pages/svip/purchase', //超级会员购买
			name: 'svipPurchase',
			meta: {
				title: '超级会员购买'
			},
			component: resolve => require(['@/pages/svip/purchase'], resolve),
		},
		{
			path: '/package/pages/svip/redpacketCoupon', //超级会员红包券
			name: 'svipRedpacketCoupon',
			meta: {
				title: '超级会员红包券'
			},
			component: resolve => require(['@/pages/svip/redpacketCoupon'], resolve),
		},
		{
			path: '/package/pages/svip/mine', //超级会员个人中心
				name: 'svipMine',
			meta: {
				title: '超级会员个人中心'
			},
			component: resolve => require(['@/pages/svip/mine'], resolve),
		},
		{
			path: '/plugin/pages/paybill/index',
			meta: {
				title: '当面付订单列表'
			},
			component: resolve => require(['@/pages/paybill/index'], resolve),
		},
		{
			path: '/plugin/pages/paybill/detail',
			meta: {
				title: '支付成功'
			},
			component: resolve => require(['@/pages/paybill/detail'], resolve),
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js